import {TOGGLE_MOBILE_MENU} from '../actionTypes'
export const toggleMobileMenu = () => {
    return{ type: TOGGLE_MOBILE_MENU }
}